import { render } from "./AppSkeletonMessage.vue?vue&type=template&id=b9c3a54c&scoped=true&ts=true"
import script from "./AppSkeletonMessage.vue?vue&type=script&lang=ts"
export * from "./AppSkeletonMessage.vue?vue&type=script&lang=ts"

import "./AppSkeletonMessage.vue?vue&type=style&index=0&id=b9c3a54c&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9c3a54c"]])

export default __exports__